<template lang="pug">
	.product-feed-chooser(v-if="showed")
		.card
			.card-header
				span Product Feed Chooser
			.card-body.collapse.show
				span.split-input
					span.split-title.text-muted Filter
					input.form-control.form-control-sm(type="text" :value="filter" v-on:input="changeFilter($event.target.value)")
				.offers-wrapper
					.offers-title {{feed.title}}
					.offers-fetching-wrapper(v-if="fetching")
						.icon.fa.fa-spinner.fa-spin
					.offers-results(v-else-if="!fetching && offersToSelect.length")
						.offer-wrapper(v-for="offer in offersToSelect" @click="selectOffer(offer)")
							.offer-checkmark
								.icon-background
									.icon.fa.fa-check(v-show="selectedOffers.find(offer_ => offer_.offer_id === offer.offer_id)")
							.offer-title {{offer.title}}
							.offer-description {{offer.description}}
							img.offer-image(:src="ProductFeed.getFeedOfferImage(offer)")
					span(v-if="!fetching && !offersToSelect.length") {{userMessage}}
					.offers-configurator(:ref="'offerFieldsConfig'" v-if="!fetching && (feed && feed.additional_data && feed.additional_data.referenceOffer && !feed.additional_data.offerFields)")
						.offer-property(v-for="property in Object.keys(offerFields)")
							p {{offerFields[property].title}}
							select.custom-select.custom-select-sm(:offer_field="property")
								option(v-for="field in availableFields" :value="field" :selected="offerFields[property].default === field") {{field}}

			.card-footer
				.form-horizontal
					.form-actions
						button.btn.btn-secondary.reload-feed(type="submit" v-on:click="loadFeed()")
							i.fa.fa-refresh
							span {{`&nbsp;&nbsp;${reloadTitle}`}}
						button.btn.btn-dark(type="button" v-on:click="close()") Close

</template>

<script>

	import Screen 				from './../../../mixins/screen'

	import { ProductFeed } 		from './../../../services/ProductFeed'

	export default {
		name: "ProductFeedChooser",
		mixins: [Screen],
		screen: {
			//updateOn: ["Product Feed Loaded", "Product Feed Offers Updated"],
			events: {

				"Product Feed Loaded": function () {
					this.fetching = false;
					this.update();
				},
				"Product Feed Offers Updated": function(params) {
					this.fetching = false;
					this.offersToSelect = params;

					if (!params.length) this.userMessage = 'No results found for the entered filter.';

					this.$forceUpdate();
				},
				"Product Feed Offers Error": function (error) {

					this.fetching = false;
					this.userMessage = error.message;
					this.offersToSelect = [];
					this.$forceUpdate();

				},
				"Show ProductFeedChooser": function(productFeedSetting) {

					//this.filter = '';

				},
				"Selected Version Setting Changed": function(settingCodename, value) {

					if (settingCodename === this.setting?.codename) {

						this.$forceUpdate();

					}

				}
			}
		},
		data() {

			this.selectedOffers = [];
			this.offersToSelect = [];

			this.userMessage = 'Please enter your filter';

			return {
				showed: false,
				filter: '',
				fetching: false,
				userMessage: '',
				reloadTitle: 'Reload Feed',
				availableFields: [],
				offerFields: {
					'brand': {
						title: 'Brand',
						default: 'vendor'
					},
					'title': {
						title: 'Title',
						default: 'name'
					},
					'description': {
						title: 'Description',
						default: 'description'
					},
					'images': {
						title: 'Images',
						default: 'picture'
					},
					'price': {
						title: 'Price',
						default: 'price'
					},
					'is_available': {
						title: 'Is available',
						default: 'pickup'
					},
					'url': {
						title: 'URL',
						default: 'url'
					}
				}
			};

		},
		methods: {
			collectData(eventName, productFeedSetting) {

				if (eventName === 'show') this.filter = '';
				if (this.filter.length === 0) this.userMessage = 'Please enter your filter';

				if (productFeedSetting) this.setting = productFeedSetting;

				this.settingValue = Settings.getSettingValue(this.setting.codename) || {};

				this.feed = _.find(ProductFeed.feeds, feed => {

					return feed["version_id"] === this.setting["version_id"] && feed["setting_codename"] === this.setting["codename"];

				});


				this.selectedOffers = this.settingValue.offers;
				this.offersToSelect = [];

				if (!this.feed) {
					this.feed = {};
					this.userMessage = 'Please reload feed';
					this.reloadTitle = 'Reload Feed';
				}
				else if (this.feed && !this.filter) {
					this.offersToSelect = _.values(ProductFeed.feedOffers[this.feed.id]);
					this.reloadTitle = 'Reload Feed';
				}

				if (this.feed.additional_data) {
					if (this.feed.additional_data.referenceOffer && !this.feed.additional_data.offerFields) {
						this.availableFields = Object.keys(this.feed.additional_data.referenceOffer);
						this.userMessage = 'Please select corresponding xml fields for offer properties';
						this.reloadTitle = 'Set Fields';
					} else {
						this.reloadTitle = 'Reload Feed';
						this.userMessage = 'Please enter your filter';
					}
				}

			},

			changeFilter(filter) {

				this.filter = filter;

				this.fetching = true;

				clearTimeout(this.changeFilterTimeout);
				this.changeFilterTimeout = setTimeout(() => {

					Server.sendToSocket({
						LoadProductFeedOffers: {
							projectId: Project.SelectedProject.id,
							versionId: Version.SelectedVersion.id,
							settingCodename: this.setting["codename"],
							filter: this.filter
						}
					});

				}, 200);

			},
			choose() {

				this.settingValue.offers = this.selectedOffers;

				Server.sendToSocket({
					UpdateProjectVersionSetting: {
						versionId: Version.SelectedVersion.id,
						settingCodename: this.setting.codename,
						value: this.settingValue
					}
				});

			},
			loadFeed() {

				this.fetching = true;

				let serverData = {
					LoadProductFeed: {
						projectId: Project.SelectedProject.id,
						versionId: Version.SelectedVersion.id,
						settingCodename: this.setting["codename"],
					}
				};

				if (this.feed.additional_data && this.feed.additional_data.referenceOffer && !this.feed.additional_data.offerFields) {
					let offerFields = {};
					let fields = this.$refs.offerFieldsConfig.querySelectorAll('select');
					fields.forEach(field => {
						offerFields[field.attributes.offer_field.value] = field.value;
					});
					serverData.LoadProductFeed.offerFields = offerFields;

				}

				Server.sendToSocket(serverData);

			},

			selectOffer(offer) {

				let selectedOffer = this.selectedOffers.find(offer_ => offer_.offer_id === offer.offer_id);

				let index = this.selectedOffers.indexOf(selectedOffer);
				if (index > -1) this.selectedOffers.splice(index, 1);
				else this.selectedOffers.push(offer);

				Server.sendToSocket({
					SaveProductFeedOffers: {
						projectId: Project.SelectedProject.id,
						versionId: Version.SelectedVersion.id,
						settingCodename: this.setting["codename"],
						offers: this.selectedOffers
					}
				});

				/*Settings.setSettingValue(this.setting.codename, {feedUrl: this.setting.value.feedUrl, offers: this.selectedOffers});

				let image = ProductFeed.getFeedOfferImage(offer);

				const img = document.createElement("img");
				img.src = image;
				img.onload = (e) => {

					console.log(e, img);

					fetch(img.src)
					.then(res => res.blob())
					.then(blob => {
					  const file = new File([blob], 'dot.png', blob)
					  console.log(file)
					})

				}




				this.$forceUpdate();*/
			},

			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.offer-description
		&::-webkit-scrollbar
			position: fixed
			width: 6px
			margin-left: -8px
			-webkit-appearance: none
			appearance: none

		&::-webkit-scrollbar-thumb
			background-color: rgba(0, 0, 0, 0.3)
			background-clip: content-box
			border-color: transparent
			border-radius: 5px

	.offers-results
		&::-webkit-scrollbar
			position: fixed
			width: 10px
			margin-left: -8px
			-webkit-appearance: none
			appearance: none

		&::-webkit-scrollbar-thumb
			background-color: rgba(0, 0, 0, 0.3)
			background-clip: content-box
			border-color: transparent
			border-radius: 5px

	.offers-configurator
		&::-webkit-scrollbar
			position: fixed
			width: 10px
			margin-left: -8px
			-webkit-appearance: none
			appearance: none

		&::-webkit-scrollbar-thumb
			background-color: rgba(0, 0, 0, 0.3)
			background-clip: content-box
			border-color: transparent
			border-radius: 5px

	.product-feed-chooser
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 800px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 500px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			>.card-body
				overflow: hidden
				display: flex
				flex-direction: column
				gap: 8px

			>.card-footer
				background-color: #343b41
				border-top: 1px solid #23282c
				display: flex

				>.form-horizontal
					width: 100%

					>.form-actions
						position: unset


			.offers-wrapper
				width: 100%
				height: 100%
				display: flex
				flex-direction: column
				align-items: center
				overflow: hidden
				gap: 5px

				>.offers-fetching-wrapper
					width: 50px
					height: 50px
					margin: auto

					>.icon
						font-size: 50px

				>.offers-configurator
					display: flex
					width: 100%
					flex-direction: column
					border: 1px solid #24282c
					border-radius: 5px
					padding: 5px
					overflow: auto

					>.offer-property
						display: flex
						flex-direction: row
						gap: 10px

						>p
							width: 120px

				>.offers-results
					display: flex
					width: 100%
					flex-direction: column
					border: 1px solid #24282c
					border-radius: 5px
					padding: 5px
					overflow: auto

					&:empty
						border: unset

					>.offer-wrapper
						display: flex
						flex-direction: row
						max-height: 100px
						border-radius: 5px
						padding: 5px
						gap: 5px
						justify-content: space-evenly
						cursor: pointer

						&:hover
							background-color: rgba(0,0,0,0.4)

						&:nth-child(2n)
							background-color: rgba(0,0,0,0.2)

						&:hover:nth-child(2n)
							background-color: rgba(0,0,0,0.4)

						>.offer-checkmark
							width: 50px
							align-items: center
							display: flex

							>.icon-background
								height: 25px
								width: 25px
								margin: auto
								border: 1px solid #23282c
								background-color: #515b65
								border-radius: 0.2rem

								>.icon
									margin: 2px
									font-size: 21px

						>.offer-title
							width: 175px
							max-height: 90px
							font-size: 0.75rem
							text-align: center
							vertical-align: center
							margin: auto
							overflow: hidden

						>.offer-description
							width: 375px
							overflow-x: hidden
							overflow-y: auto
							font-size: 0.75rem
							line-height: 0.8rem

						>.offer-image
							object-fit: contain
							height: 95%
							max-width: 15%
							min-width: 15%



			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.reload-feed
				margin-left: 20px

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.split-input
				display: flex
				white-space: nowrap
				line-height: 30px
				margin: 0 10px

				.split-title
					align-items: center
					padding: .17rem .75rem 0 .75rem
					margin-bottom: 0
					font-size: .875rem
					font-weight: 400
					line-height: 1.5
					color: #e4e7ea
					text-align: center
					white-space: nowrap
					margin-right: -1px
					background-color: #343b41
					background-clip: border-box
					border: 1px solid #23282c
					border-top-left-radius: .25rem
					border-bottom-left-radius: .25rem

				input
					border-top-left-radius: 0
					border-bottom-left-radius: 0

</style>

